import { useNavigate } from 'react-router-dom';
import { Button, Menu, MenuItem, Stack } from 'ui';
import { ArrowDropDown } from 'ui/icons';

export const ManageDataButton = () => {
  const navigate = useNavigate();
  const options = [
    {
      label: 'AI Bale Photos',
      onClick: () => navigate('ai-bale'),
    },
    {
      label: 'Marketing Media',
      onClick: () => navigate('marketing'),
    },
    {
      label: 'Loading Evidence',
      onClick: () => navigate('loading'),
    },
    {
      label: 'Site Evidence',
      onClick: () => navigate('site'),
    },
    {
      label: 'Samples',
      onClick: () => navigate('sample'),
    },
    {
      disabled: true,
      label: 'Specifications',
      onClick: () => navigate(''),
    },
  ];

  return (
    <Stack direction="row" width="100%" gap={2}>
      <Menu
        button={
          <Button fullWidth endIcon={<ArrowDropDown />}>
            Manage Data
          </Button>
        }
      >
        {options.map((option) => (
          <MenuItem key={option.label} onClick={option.onClick} disabled={option.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};
